<template>
  <!-- check 为 false 有两种情况：没有大盘数据权限，或者数据还没回来。
       所以这里只做中性的欢迎语，不写"无权限"这种可能不成立的断言。 -->
  <div class="home home-welcome" v-if="!check">
    <img src="@/assets/logo-mark.svg" alt="" class="welcome-mark">
    <h1 class="welcome-title">老板好</h1>
    <p class="welcome-sub">从左侧选择一个功能开始</p>
  </div>

  <div class="home" v-if="check">
    <div class="form-container">
      <search-form  @submit="onFormSubmit" @reset="onFormReset">
        <a-form-item label="包名" name="shadowType">
          <a-select v-model:value="query.shadowType" :options="shadowTypeOptions" style="width: 120px">
          </a-select>
        </a-form-item>
        <a-form-item label="环比类型" name="type">
          <a-select v-model:value="query.type" :options="typeOptions" style="width: 120px">
          </a-select>
        </a-form-item>
      </search-form>
    </div>

    <a-card title="平台实时数据" >
      <a-card-grid style="width: 33.3%; text-align: center">
        <span style="line-height:70px;font-size:20px;font-weight:bold; "><span style="margin-left: 5px;">充值金额:  {{data.recharge/100}}</span> <span
        style="font-size: 14px;font-weight:normal;"><img
        :src="(data.rechargeTb !== null && data.rechargeTb >= 0) ? (data.rechargeTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.rechargeTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>
      <a-card-grid style="width: 33.3%; text-align: center" >
        <span style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">新用户充值金额:   {{data.newUserRecharge/100}}</span> <span
        style="font-size: 14px;font-weight:normal;"><img
        :src="(data.newUserRechargeTb !== null && data.newUserRechargeTb >= 0) ? (data.newUserRechargeTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.newUserRechargeTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>
      <a-card-grid style="width: 33.3%; text-align: center">
        <span style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">新户充值人数:   {{data.newUserRechargeMemberCount}}</span> <span
        style="font-size: 14px;font-weight:normal;"> <img
        :src="(data.newUserRechargeMemberCountTb !== null && data.newUserRechargeMemberCountTb >= 0) ? (data.newUserRechargeMemberCountTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.newUserRechargeMemberCountTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>

      <a-card-grid style="width: 33.3%; text-align: center">
        <span style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">女用户提现金额:   {{data.femaleWithdrawalRecharge}} </span> <span
        style="font-size: 14px;font-weight:normal;"><img
        :src="(data.femaleWithdrawalRechargeTb !== null && data.femaleWithdrawalRechargeTb >= 0) ? (data.femaleWithdrawalRechargeTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.femaleWithdrawalRechargeTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>
      <a-card-grid style="width: 33.3%; text-align: center">
        <span style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">新增女用户（pgc）:   {{data.newPgcCount}} </span> <span
        style="font-size: 14px;font-weight:normal;"><img
        :src="(data.newPgcCountTb !== null && data.newPgcCountTb >= 0) ? (data.newPgcCountTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.newPgcCountTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>
      <a-card-grid style="width: 33.3%; text-align: center">
        <span
        style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">活跃女用户（pgc）:   {{data.onlinePgcCount}} </span> <span
        style="font-size: 14px;font-weight:normal;"><img
        :src="(data.onlinePgcCountTb !== null && data.onlinePgcCountTb >= 0) ? (data.onlinePgcCountTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.onlinePgcCountTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>

      <a-card-grid style="width: 33.3%; text-align: center">
        <span style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">新增男用户:   {{data.newManCount}} </span> <span
        style="font-size: 14px;font-weight:normal;"><img
        :src="(data.newManCountTb !== null && data.newManCountTb >= 0) ? (data.newManCountTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.newManCountTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>
      <a-card-grid style="width: 33.3%; text-align: center">
        <span style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">活跃男用户:   {{data.onlineManCount}} </span> <span
        style="font-size: 14px;font-weight:normal;"><img
        :src="(data.onlineManCountTb !== null && data.onlineManCountTb >= 0) ? (data.onlineManCountTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.onlineManCountTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>
      <a-card-grid style="width: 33.3%; text-align: center">
        <span style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">男用户次留:   {{parseFloat(data.yesterdayNewUserTodayLoginRate*100).toFixed(2) + '%'}} </span> <span
        style="font-size: 14px;font-weight:normal;"><img
        :src="(data.yesterdayNewUserTodayLoginRateTb !== null && data.yesterdayNewUserTodayLoginRateTb >= 0) ? (data.yesterdayNewUserTodayLoginRateTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.yesterdayNewUserTodayLoginRateTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>

      <a-card-grid style="width: 33.3%; text-align: center">
        <span
        style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">充值人数:   {{data.rechargeMemberCount}} </span> <span
        style="font-size: 14px;font-weight:normal;"><img
        :src="(data.rechargeMemberCountTb !== null && data.rechargeMemberCountTb >= 0) ? (data.rechargeMemberCountTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.rechargeMemberCountTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>
      <a-card-grid style="width: 33.3%; text-align: center">
        <span
        style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">充值次数:   {{data.rechargeCount}} </span> <span
        style="font-size: 14px;font-weight:normal;"><img
        :src="(data.rechargeCountTb !== null && data.rechargeCountTb >= 0) ? (data.rechargeCountTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.rechargeCountTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>
      <a-card-grid style="width: 33.3%; text-align: center">
        <span style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">昨日充值人数:   {{data.yesterdayRechargeMemberCount}}</span>
        <span style="font-size: 14px;font-weight:normal;"></span></span>
      </a-card-grid>

      <a-card-grid style="width: 33.3%; text-align: center"><span style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">新户充值次数:   {{data.newUserRechargeCount}} </span> <span
        style="font-size: 14px;font-weight:normal;"><img
        :src="(data.newUserRechargeCountTb !== null && data.newUserRechargeCountTb >= 0) ? (data.newUserRechargeCountTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.newUserRechargeCountTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>
      <a-card-grid style="width: 33.3%; text-align: center"><span style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">老户充值人数:   {{data.oldUserRechargeMemberCount}} </span> <span
        style="font-size: 14px;font-weight:normal;"><img
        :src="(data.oldUserRechargeMemberCountTb !== null && data.oldUserRechargeMemberCountTb >= 0) ? (data.oldUserRechargeMemberCountTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.oldUserRechargeMemberCountTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>
      <a-card-grid style="width: 33.3%; text-align: center"><span style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">老户充值次数:   {{data.oldUserRechargeCount}} </span> <span
        style="font-size: 14px;font-weight:normal;"><img
        :src="(data.oldUserRechargeCountTb !== null && data.oldUserRechargeCountTb >= 0) ? (data.oldUserRechargeCountTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.oldUserRechargeCountTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>

      <a-card-grid style="width: 33.3%; text-align: center"><span style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">新户付费率:   {{parseFloat(data.newUserPayRate*100).toFixed(2) + '%'}}</span> <span
        style="font-size: 14px;font-weight:normal;"> <img
        :src="(data.newUserPayRateTb !== null && data.newUserPayRateTb >= 0) ? (data.newUserPayRateTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.newUserPayRateTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>
      <a-card-grid style="width: 33.3%; text-align: center"><span style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">老户付费率:   {{parseFloat(data.oldUserPayRate*100).toFixed(2) + '%'}}</span> <span
        style="font-size: 14px;font-weight:normal;"> <img
        :src="(data.oldUserPayRateTb !== null && data.oldUserPayRateTb >= 0) ? (data.oldUserPayRateTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.oldUserPayRateTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>
      <a-card-grid style="width: 33.3%; text-align: center"><span style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">充值用户次留:   {{parseFloat(data.rechargeUserTomorrowOnlineRate*100).toFixed(2) + '%'}} </span> <span
        style="font-size: 14px;font-weight:normal;"><img
        :src="(data.rechargeUserTomorrowOnlineRateTb !== null && data.rechargeUserTomorrowOnlineRateTb >= 0) ? (data.rechargeUserTomorrowOnlineRateTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.rechargeUserTomorrowOnlineRateTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>

      <a-card-grid style="width: 33.3%; text-align: center"><span style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">充值用户第二天再次付费率:   {{parseFloat(data.rechargeUserTomorrowPayRate*100).toFixed(2) + '%'}}</span> <span
        style="font-size: 14px;font-weight:normal;"> <img
        :src="(data.rechargeUserTomorrowPayRateTb !== null && data.rechargeUserTomorrowPayRateTb >= 0) ? (data.rechargeUserTomorrowPayRateTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.rechargeUserTomorrowPayRateTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>
      <a-card-grid style="width: 33.3%; text-align: center"><span
        style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">邀请充值总额:   {{data.inviteRecharge/100}} </span> <span
        style="font-size: 14px;font-weight:normal;"><img
        :src="(data.inviteRechargeTb !== null && data.inviteRechargeTb >= 0) ? (data.inviteRechargeTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.inviteRechargeTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>
      <a-card-grid style="width: 33.3%; text-align: center"><span style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">今日邀请充值:   {{data.todayInviteRecharge/100}} </span> <span
        style="font-size: 14px;font-weight:normal;"><img
        :src="(data.todayInviteRechargeTb !== null && data.todayInviteRechargeTb >= 0) ? (data.todayInviteRechargeTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.todayInviteRechargeTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>

      <a-card-grid style="width: 33.3%; text-align: center"><span style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">当日VIP充值金额:   {{data.vipRechargeMoney/100}}</span> <span
        style="font-size: 14px;font-weight:normal;"> <img
        :src="(data.vipRechargeMoneyTb !== null && data.vipRechargeMoneyTb >= 0) ? (data.vipRechargeMoneyTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.vipRechargeMoneyTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>
      <a-card-grid style="width: 33.3%; text-align: center"><span
        style="line-height:70px;font-size:20px;font-weight:bold "><span style="margin-left: 5px;">当日充值VIP人数:   {{data.vipRechargeMemberCount}} </span> <span
        style="font-size: 14px;font-weight:normal;"><img
        :src="(data.vipRechargeMemberCountTb !== null && data.vipRechargeMemberCountTb >= 0) ? (data.vipRechargeMemberCountTb == 0 ? arrowEquals : arrowUp) : arrowDown"/>{{parseFloat(data.vipRechargeMemberCountTb*100).toFixed(2) + '%'}}</span></span>
      </a-card-grid>
    </a-card>

    <div id="main" style="position: relative; top: 100px; width: 50%; height: 400px"></div>

  </div>
</template>

<script>
  // @ is an alias to /src
  import {defineComponent, reactive, ref} from 'vue'
  import {getLargeMarketStat, getMenus, getUserInfo} from '@/api/admin-user'
  import {message} from 'ant-design-vue'
  import Image from "@/components/Image.vue";
  import * as echarts from "echarts";
  import SearchForm from '@/components/SearchForm.vue'

  export default defineComponent({
    name: 'Home',
    components: {
      Image,
      SearchForm
    },
    setup() {
      const data = ref({})
      const chartData = ref([])
      const check = ref(false)
      const arrowDown = ref("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAATlBMVEUAAAAAp1QAqFMArk8AqVMAqFMAqFMAmmEAoVsAoVoAn1wAoVsAoVsApVcArVAAp1QArk8AsE0AqFQAyTQAzy8AqVMAqVMAmWIAoFwAn1yPLoA+AAAAFnRSTlMAlOKgNyQZ9vLw6ce7sayVbFxEOzIsIbkEPgAAAEhJREFUCNdjIAzYGBkZ+VnhXBYxIBCCc0VBXBaEYhAXpliQkwnEZeIQgPCZxUFccT4gE84X50XYxCMpwY1sMxc7ikNEhBmIAAB+UwNv88frPAAAAABJRU5ErkJggg==")
      const arrowUp = ref("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAARVBMVEUAAADwQTTwQTT1Qi3xPzL2RCfxQDLuPzbuPTvvPzjxPzbyPzfzQDP0Qi70QDH1QDHvQDPvQDP6SRzyPzLxQTTtPT3uQDgKeuofAAAAFHRSTlMAl/CNNSchDunbuKuhmG1cRTAtGtsJIZsAAABJSURBVAjXYyAGsAqhcDk5kHncYmJcCB6zqIiIKA8yD8jnhfD4xZhAXCYxPjCXnYENxBUEMqDWgLgscKNYQFwBOFeYEQjYCDsWAD1iA0HeY4cqAAAAAElFTkSuQmCC")
      const arrowEquals = ref("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOBAMAAADtZjDiAAAAFVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAASAQCkAAAABnRSTlMAh6+rT05LwO+cAAAAHElEQVQI12MgGgQKCgqKAGmztLS0JBgNFycWAAALowTFYXTpKwAAAABJRU5ErkJggg==")

      const query = reactive({
        shadowType: 'all',
        type: 'week'
      })

      const shadowTypeOptions = ref([
        {
          value: 'all',
          label: '全部'
        },
        {
          value: 'taoyu',
          label: '夕梦'
        },
        // {
        //   value: 'ilove',
        //   label: '去爱'
        // },
        // {
        //   value: 'boyu',
        //   label: '波遇'
        // },
        // {
        //   value: 'idol',
        //   label: '爱豆'
        // },
        {
          value: 'glove',
          label: '去恋'
        },
        {
          value: 'meetlove',
          label: '遇对'
        }
      ])

      const typeOptions = ref([
        {
          value: 'week',
          label: '周环比'
        },
        {
          value: 'day',
          label: '日环比'
        }
      ])

      const chartInit = () => {
          let myChart = echarts.init(document.getElementById('main'));
          let option = {
              title: {
                  text: '金币消耗分布',
                  top: "0%",
                  left: "center"
              },
              series: [
                  {
                      type: "pie",
                      label: {
                          show: true,
                          formatter: "{b} :{d}%" //  {c}
                      },
                      data: chartData.value
                  }
              ]
          };
          // 使用刚指定的配置项和数据显示图表。
          myChart.setOption(option);
      }

      const initData = () => {
        getMenus().then(res => {
          if (res.success) {
            let newMenu = res.data.newMenu;
            let filter = newMenu.filter(i => i.name ==="首页");
            if (!filter || !filter[0]) {
               return;
            }

            let menu = filter[0];

            for (let i = 0; i < menu.children.length; i++) {
              if (menu.children[i].path === '/home') {
                largeMarketStat();
              }
            }
          } else {
            message.error(res.message)
          }
        }).catch(error => {
          message.error(error.message)
        }).finally(() => {
        })
      }

      initData()

      const largeMarketStat = () => {
        check.value = true
        getLargeMarketStat(query).then(res => {
          if (res.success) {
            data.value = res.data
            if (data.value.goldConsumerGroup !== undefined &&  data.value.goldConsumerGroup != null) {
              let temp = []
              if (data.value.goldConsumerGroup.text > 0) {
                temp.push({
                  value: data.value.goldConsumerGroup.text,
                  name: "消息"
                })
              }
              if (data.value.goldConsumerGroup.media > 0) {
                temp.push({
                  value: data.value.goldConsumerGroup.media,
                  name: "视频"
                })
              }
              if (data.value.goldConsumerGroup.audio > 0) {
                temp.push({
                  value: data.value.goldConsumerGroup.audio,
                  name: "音频"
                })
              }
              if (data.value.goldConsumerGroup.gift > 0) {
                temp.push({
                  value: data.value.goldConsumerGroup.gift,
                  name: "礼物"
                })
              }
              if (data.value.goldConsumerGroup.other > 0) {
                temp.push({
                  value: data.value.goldConsumerGroup.other,
                  name: "其它"
                })
              }
              chartData.value = temp;
            }

            chartInit()
          } else {
            message.error(res.message)
          }
        }).catch(error => {
          console.log("error", error)
          message.error(error.message)
        }).finally(() => {
        })
      }

      const initUser = () => {
        getUserInfo().then(res => {
          if (res.success) {
            console.log('加油努力为了人民币')
          } else {
            message.error(res.message)
          }
        }).catch(error => {
          message.error(error.message)
        }).finally(() => {
        })
      }

      initUser()

      const onFormSubmit = () => {
        largeMarketStat();
      }
      const onFormReset = () => {
        query.shadowType = 'all'
        query.type = 'week'
        largeMarketStat();
      }

      return {
        chartInit,
        data,
        arrowDown,
        arrowUp,
        arrowEquals,
        check,
        query,
        shadowTypeOptions,
        typeOptions,
        onFormSubmit,
        onFormReset,
      }
    }
  })
</script>

<style scoped lang="less">
@import '@/style/variables.less';

.home-welcome {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 52vh;
  text-align: center;
}
.welcome-mark {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  opacity: .9;
  margin-bottom: 18px;
}
.welcome-title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: @text-1;
  letter-spacing: .04em;
}
.welcome-sub {
  margin: 8px 0 0;
  font-size: 13px;
  color: @text-3;
}
</style>
